import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  @Input() data: any;

  constructor(public sidebarService: SidebarService) {}

  close() {
    this.sidebarService.destroyComponent();
  }
}
